<div class="flex flex-col w-full gap-1.5 task-activity">
  @if (groupContainsTimelineEvent()) {
    <div class="flex w-full items-center justify-center">
      <div class="flex w-full items-center justify-center flex-col gap-1">
        @for (taskActivity of groupedTaskTimelineEvents(); track taskActivity.id) {
          <div class="w-full flex flex-row items-center justify-center gap-1.5">
            <div
              class="flex w-full min-w-0 flex-wrap items-baseline gap-x-1.5 gap-y-1 hover:bg-proffeo-surface-muted rounded-lg"
            >
              @if (taskActivity.user?.()) {
                <span class="min-w-0 break-words text-proffeo-muted text-sm">
                  {{ taskActivity.user?.()?.firstName }} {{ taskActivity.user?.()?.lastName }} -
                </span>
              }

              <proffeo-task-activity-content
                [activity]="taskActivity"
                class="block min-w-0 basis-full break-words whitespace-normal"
              ></proffeo-task-activity-content>
              @if (taskActivity.date && taskActivity.taskActivityType !== TaskActivityType.TaskMessageAdded) {
                <span class="flex-shrink-0 text-nowrap text-proffeo-muted text-sm bg-transparent ml-auto">
                  {{ taskActivity.date | proffeoDate: defaultTimeFormat }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (groupedTaskActivities()[0].taskActivityType === TaskActivityType.TaskMessageAdded) {
    <div
      [class.ml-auto]="groupedTaskActivities()[0].user?.()?.id === currentUserId()"
      class="flex min-w-0 items-start gap-1.5 w-full"
    >
      @if (groupedTaskActivities()[0].user?.()?.id !== currentUserId()) {
        <proffeo-avatar
          [user]="$safeNavigationMigration(groupedTaskActivities()[0].user?.())"
          [size]="AvatarSize.SM"
          class="shrink-0"
        ></proffeo-avatar>
      }
      <div
        [ngClass]="
          groupedTaskActivities()[0].user?.()?.id === currentUserId()
            ? 'bg-proffeo-surface-subtle'
            : 'bg-proffeo-surface-muted'
        "
        class="flex min-w-0 flex-1 flex-col px-3 pb-3 pt-1 rounded-lg border border-proffeo-overlay-subtle"
      >
        <div class="flex flex-wrap justify-between items-baseline gap-1 w-full pb-2">
          @if (groupedTaskActivities()[0].user?.()) {
            <div class="flex items-center gap-[0.6rem]">
              <span class="text-proffeo-muted text-sm">
                {{ groupedTaskActivities()[0].user?.()?.firstName }}
                {{ groupedTaskActivities()[0].user?.()?.lastName }}
              </span>
            </div>
          }

          @if (groupedTaskActivities()[0].date) {
            <span
              #tooltip="matTooltip"
              matTooltip="{{ groupedTaskActivities()[0].date | proffeoDate: defaultDatetimeFormat }}"
              matTooltipPosition="left"
              class="text-proffeo-muted text-sm"
            >
              {{ groupedTaskActivities()[0].date | proffeoDate: defaultTimeFormat }}
            </span>
          }
        </div>

        @for (taskActivity of groupedTaskActivities(); track taskActivity.id) {
          <div>
            @if (taskActivity.taskActivityType === TaskActivityType.TaskMessageAdded) {
              <proffeo-message-added-activity [activity]="taskActivity" />
            }
          </div>
        }
      </div>
    </div>
  }
</div>
